import React from "react";
import userIcon from "styles/images/components/friends/userIcon.svg";
import discordLogo from "styles/images/components/navbar/discordLogo.svg";
import twitterXLogo from "styles/images/components/navbar/twitterXLogo.svg";
import { motion } from "framer-motion";
import { Link, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "stores/Store";
import { setGame } from "stores/game/GameSlice";
import { setLobby } from "stores/lobby/LobbySlice";

function FriendList() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const user = useSelector((state: RootState) => state.userReducer.user);

  return (
    <div className="FriendList">
      <motion.img
        style={{ cursor: "pointer" }}
        src={userIcon}
        alt="user icon"
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.9 }}
        className="userIcon"
        onClick={() => {
          navigate(`/user/${user?.uid}`);
          dispatch(setGame(null));
          dispatch(setLobby(null));
        }}
      />
      <div className="friendListContainer">&nbsp;</div>
      <div className="socials">
        <Link
          to="https://twitter.com/Drafter_GG"
          target="_blank"
          rel="noopener noreferrer"
        >
          <motion.img
            alt="Twitter X Logo"
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.9 }}
            src={twitterXLogo}
          />
        </Link>
        <Link
          to="https://discord.gg/BSYKzQXcv4"
          target="_blank"
          rel="noopener noreferrer"
        >
          <motion.img
            alt="Discord Logo"
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.9 }}
            src={discordLogo}
          />
        </Link>
      </div>
    </div>
  );
}

export default FriendList;
